import React, { useEffect, useState } from "react";
import ReactGA from 'react-ga4';
import { Auth } from "aws-amplify";
import axios from "axios";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import { AlertTitle, CircularProgress, Divider, List, ListItem } from "@mui/material";
import MuiAlert from '@mui/material/Alert';
import { useTranslation } from 'react-i18next';

import Dashboard from "./Dashboard";
import School from "./School";
import Facilitator from "./Facilitator";
// import ExcelUpload from "./ExcelUpload";
import Report from "./Report";
import Students from "./Students"
import StudentExcelUpload from "./StudentExcelUpload";
import Dropbox from "./Dropbox";

// Custom hook to log page views on route changes
function usePageView() {
  const location = useLocation();
  useEffect(() => {
    ReactGA.send({
      hitType: "pageview",
      page: window.location.pathname,
      user: "Admin",
      // product_id: productId, // Assuming productId is a variable
    });
    // console.log(window.location.pathname)
  }, [location]);
}

const AdminContent = () => {
  usePageView()

  const [adminInfo, setAdminInfo] = useState("")
  const [error, setError] = useState(false)
  const [errorMsg, setErrorMsg] = useState([])

  const { t } = useTranslation();

  useEffect(() => {
    Auth.currentSession()
    .then((data) => {
      const jwtToken = data.idToken.jwtToken;
      const cognitoUsername = data.idToken.payload["cognito:username"];

      const getAdminInfo = async() => {
        try {
          const response =  await axios.get("https://zk1128nq2f.execute-api.ap-south-1.amazonaws.com/alpha/admin/"+cognitoUsername, {
            headers: {
              'Content-Type': 'application/json',
              'Authorization': jwtToken
            }
          });
          // console.log(response.data)
          if(response.data.test.lang){
            setAdminInfo(response.data)
          }
          else{
            setError(true)
            setErrorMsg(["LANG_NOT_FOUND", "Latest Test does not contain any languages"])
          }
        }
        catch (error) {
          setError(true)
          setErrorMsg([error.code, error.message])
          console.log(error)
        }
      }

      getAdminInfo()
    })
    .catch((err) => console.log(err));
    
  }, []);

  return (
    <div className="content">
      {adminInfo 
        ? 
        <>
          {adminInfo.notification && 
            <div style={{display: "flex", backgroundColor: "rgb(255, 244, 229)", padding: "6px 12px", borderRadius: "6px"}}>
              <p style={{fontSize: "14px", color: "rgb(102, 60, 0)"}}> <b>Info:</b> {adminInfo.notification}</p>
            </div>        
          }
          <Routes>
            <Route path="/" element={<Dashboard />} />
            <Route path="/school" element={<School adminInfo={adminInfo}/>} />
            <Route path="/facilitator" element={<Facilitator adminInfo={adminInfo}/>} />
            {/* <Route path="/excel-upload" element={<ExcelUpload adminInfo={adminInfo}/>} /> */}
            <Route path="/students" element={<Students adminInfo={adminInfo}/>} />
            <Route path="/student-excel-upload" element={<StudentExcelUpload adminInfo={adminInfo}/>} />
            <Route path="/dropbox" element={<Dropbox adminInfo={adminInfo}/>} />
            <Route path="/results" element={<Report adminInfo={adminInfo}/>} />
            <Route path="*" element={<Navigate to="/" replace/>} />
          </Routes>
        </>
        :
        <div className="blankScreen">
          {error 
            ?
            <MuiAlert severity="warning" className="blankScreenError" sx={{borderRadius: "10px"}}>
              <AlertTitle><h3>{t("commonItems.error_network_label")}</h3></AlertTitle>
                <Divider/>
                <List>
                  <ListItem disableGutters><h3>{t("commonItems.error_network_line1")}</h3></ListItem>
                  <ListItem disableGutters>
                    <p>{t("commonItems.error_network_line2")} <span></span>
                      <a href="https://forms.gle/fnU48UpGWWs5zgoT6" target="_blank" rel="noopener noreferrer" style={{color: "rgb(25, 118, 210)", textDecoration: "underline", textUnderlinePosition: "under"}}>
                        {t("commonItems.error_network_line2_formLinkLabel")}
                      </a>
                    </p>
                  </ListItem>
                  {errorMsg && 
                    <ListItem disableGutters>
                      <p>
                        {t("commonItems.error_network_response", {code: errorMsg[0], msg: errorMsg[1]})}
                      </p>
                    </ListItem>
                  }
                </List>
            </MuiAlert>
            :
            <CircularProgress color="info"/>
          }
        </div>
      }
    </div>
  )
};

export default AdminContent;
